/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_area_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes — an area conversion factor is always the linear factor squared. This converter already does that internally, so you don't need to calculate it yourself, but it's why, for example, the m²-to-ft² factor (10.764) is roughly the square of the m-to-ft factor (3.281² ≈ 10.77, close but not identical due to rounding).`)
};

const es_uc_area_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí — un factor de conversión de área es siempre el factor lineal al cuadrado. Este conversor ya hace eso internamente, así que no necesitas calcularlo tú mismo, pero es por qué, por ejemplo, el factor m²-a-ft² (10.764) es aproximadamente el cuadrado del factor m-a-ft (3.281² ≈ 10.77, cercano pero no idéntico debido al redondeo).`)
};

const de_uc_area_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja — ein Flächen-Umrechnungsfaktor ist immer der quadrierte lineare Faktor. Dieser Umrechner macht das intern bereits so, Sie müssen es also nicht selbst berechnen, aber deshalb ist zum Beispiel der m²-zu-ft²-Faktor (10.764) ungefähr das Quadrat des m-zu-ft-Faktors (3.281² ≈ 10.77, nahe dran, aber wegen Rundung nicht identisch).`)
};

const nl_uc_area_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja — een oppervlakte conversiefactor is altijd de lineaire factor in het vierkant. Deze convertor doet dat al intern, dus u hoeft het niet zelf te berekenen, maar het is waarom bijvoorbeeld de m²-naar-ft² factor (10.764) ruwweg het vierkant van de m-naar-ft factor is (3.281² ≈ 10.77, dicht maar niet identiek vanwege afronding).`)
};

const fr_uc_area_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui — un facteur de conversion de superficie est toujours le facteur linéaire au carré. Ce convertisseur le fait déjà en interne, donc vous n'avez pas besoin de le calculer vous-même, mais c'est pourquoi, par exemple, le facteur m² à ft² (10,764) est à peu près le carré du facteur m à ft (3,281² ≈ 10,77, proche mais pas identique en raison de l'arrondi).`)
};

const it_uc_area_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì — un fattore di conversione di area è sempre il fattore lineare al quadrato. Questo convertitore lo fa già internamente, quindi non è necessario calcolarlo da solo, ma è il motivo per cui, ad esempio, il fattore m²-a-ft² (10.764) è approssimativamente il quadrato del fattore m-a-ft (3,281² ≈ 10,77, vicino ma non identico a causa dell'arrotondamento).`)
};

const pt_br2_uc_area_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim — um fator de conversão de área é sempre o fator linear ao quadrado. Este conversor já faz isso internamente, então você não precisa calcular você mesmo, mas é por que, por exemplo, o fator m²-para-ft² (10.764) é aproximadamente o quadrado do fator m-para-ft (3.281² ≈ 10.77, próximo mas não idêntico devido ao arredondamento).`)
};

const pt_uc_area_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim — um factor de conversão de área é sempre o factor linear elevado ao quadrado. Este conversor já faz isso internamente, portanto não precisa de o calcular a si, mas é porque, por exemplo, o factor m²-para-ft² (10,764) é aproximadamente o quadrado do factor m-para-ft (3,281² ≈ 10,77, próximo mas não idêntico devido a arredondamento).`)
};

const ja_uc_area_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい — 面積変換係数は常に線形係数の二乗です。このコンバーターは内部でそれを既に行っているため、自分で計算する必要はありませんが、例えば、m²-to-ft²係数(10.764)が大体m-to-ft係数の二乗(3.281² ≈ 10.77、丸めによる厳密ではありませんが)である理由です。`)
};

const zh_uc_area_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_area_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_area_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_area_faq4_a", locale)
	if (locale === "en") return en_uc_area_faq4_a(inputs)
	if (locale === "es") return es_uc_area_faq4_a(inputs)
	if (locale === "de") return de_uc_area_faq4_a(inputs)
	if (locale === "nl") return nl_uc_area_faq4_a(inputs)
	if (locale === "fr") return fr_uc_area_faq4_a(inputs)
	if (locale === "it") return it_uc_area_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_area_faq4_a(inputs)
	if (locale === "pt") return pt_uc_area_faq4_a(inputs)
	if (locale === "ja") return ja_uc_area_faq4_a(inputs)
	return zh_uc_area_faq4_a(inputs)
};